import Action from 'redux/helpers/createAction'
const name = 'seoChecklist'

export const loadChecklist = Action(name + '/LOAD_CHECKLIST', domainId => ({
  domainId
}))

export const loadChecklistSuccess = Action(
  name + '/LOAD_CHECKLIST_SUCCESS',
  (domainId, checklist) => ({
    domainId,
    checklist
  })
)

export const loadChecklistFailure = Action(name + '/LOAD_CHECKLIST_FAILURE', error => ({
  error
}))

export const updateChecklist = Action(
  name + '/UPDATE_CHECKLIST',
  (domainId, section, checklist) => ({
    domainId,
    section,
    checklist
  })
)

export const updateChecklistSuccess = Action(
  name + '/UPDATE_CHECKLIST_SUCCESS',
  (domainId, section, checklist) => ({
    domainId,
    section,
    checklist
  })
)

export const updateChecklistFailure = Action(name + '/UPDATE_CHECKLIST_FAILURE', error => ({
  error
}))

export const getSeoChecklistDomains = Action(name + '/GET_SEO_CHECKLIST_DOMAINS')

export const getSeoChecklistDomainsSuccess = Action(
  name + '/GET_SEO_CHECKLIST_DOMAINS_SUCCESS',
  domains => ({
    domains
  })
)

export const getSeoChecklistDomainsFailure = Action(
  name + '/GET_SEO_CHECKLIST_DOMAINS_FAILURE',
  error => ({
    error
  })
)

export const sortSeoChecklistDomains = Action(
  name + '/SORT_SEO_CHECKLIST_DOMAINS',
  (value, order) => ({
    value,
    order
  })
)
